export default __webpack_public_path__ + "static/media/import.ecc96deb.svg";